import { TUNNEL_ROOF, tunnelHeadroom } from './tunnels.js';

/** A shared underground boundary height, inferred from low ground along the shared edge. */
export function tunnelEdgeFloor(ground: (x: number, z: number) => number, width: number, depth: number) {
  return (x: number, z: number, style: number): number => {
    const cx = Math.max(0, Math.min(width, x)), cz = Math.max(0, Math.min(depth, z));
    const distances = [cx, width - cx, cz, depth - cz];
    const edge = distances.indexOf(Math.min(...distances));
    const vertical = edge < 2, fixed = edge === 0 || edge === 2 ? 0 : vertical ? width : depth;
    const along = vertical ? cz : cx, limit = vertical ? depth : width;
    const at = (s: number) => vertical ? ground(fixed, s) : ground(s, fixed);
    let top = at(along);
    // Both tiles see the same edge, even when their interiors or load order
    // differ. Nearby low ground is a better portal-height estimate than the
    // hill directly over a bored tunnel. Do not force the bore up that hill.
    for (let d = -500; d <= 500; d += 10) {
      const s = Math.max(0, Math.min(limit, along + d));
      top = Math.min(top, at(s) + Math.abs(s - along) * 0.01);
    }
    return top - Math.max(9, tunnelHeadroom(style) + TUNNEL_ROOF + 1.5);
  };
}
